import dayjs from 'dayjs';
import {
  PickupBranch,
  PickupBranchAddress,
  WEEK_DAYS,
  WeekDaysFlags,
} from '@/pages/Business/pages/PickupCycles/models';

// El back puede devolver "11:00:00"; siempre mostramos "HH:mm".
export const formatCycleTime = (rawTime?: string | null): string => {
  if (!rawTime) return '';
  const [hours = '00', minutes = '00'] = rawTime.split(':');
  return `${hours.padStart(2, '0')}:${minutes.padStart(2, '0')}`;
};

export const cycleTimeToDate = (rawTime?: string | null): Date | null => {
  const formatted = formatCycleTime(rawTime);
  if (!formatted) return null;
  const [hours, minutes] = formatted.split(':').map(Number);
  return dayjs().hour(hours).minute(minutes).second(0).millisecond(0).toDate();
};

export const dateToCycleTime = (date: Date | null): string => {
  if (!date) return '';
  return dayjs(date).format('HH:mm');
};

export const formatActiveDays = (days: WeekDaysFlags): string => {
  const activeLabels = WEEK_DAYS.filter((day) => days[day.key]).map(
    (day) => day.label,
  );

  if (activeLabels.length === 0) return '⚠️ Sin días';
  if (activeLabels.length === WEEK_DAYS.length) return 'Todos';
  return activeLabels.join(', ');
};

export const formatBranchAddress = (
  address?: PickupBranchAddress | null,
): string | null => {
  if (!address || !address.streetName) return null;
  const doorNumber = address.doorNumber ? ` ${address.doorNumber}` : '';
  return `${address.streetName}${doorNumber}`.trim();
};

// Cuando el ciclo no tiene sucursal, el sistema usa la "casa central" del
// comercio; la ubicamos por nombre dentro de las sucursales del comercio.
export const findCentralBranch = (
  branches: PickupBranch[],
): PickupBranch | undefined =>
  branches.find((branch) => branch.name?.toLowerCase().includes('casa central'));
